import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

import useFetchWrapper, { HttpResponse } from '../../Helpers/useFetchWrapper';

import {
	FormData,
	Props,
	Participant,
	UsersResponse,
} from './CreateSurvey.model';

const useCreateSurvey = ({ onClose }: Props) => {
	const [ members, setMembers ] = useState<Participant[]>([]);
	const [ participants, setParticipants ] = useState<Participant[]>([]);
	const [openAddRespondent, setOpenAddRespondent] = useState<boolean>(false);
	const [searchName, setSearchName] = useState<string| null>("");
	
 	const defaultValues: any = {
		respondents: [],
		surveyLink: null,
		surveyType: null,
	};
	 
	 useEffect(() => {
		 getMembersList();
	 }, [searchName]);

	const { control, formState: { errors }, handleSubmit } = useForm({ defaultValues });

	const { get, post } = useFetchWrapper();

	useEffect(() => {
		getMembersList();
	}, []);

	const getMembersList = async () => {
		const response: HttpResponse<UsersResponse> = await get(`/user/all?page=${1}&size=${9999}&name=${searchName}`);
		response.parsedBody && setMembers(response.parsedBody.users);
	};

	const addRespondent = (participant: Participant) => {
		setMembers(members.filter((item) => item.userId !== participant.userId));
		setParticipants([
			...participants,
			participant,
		]);
	};
	
	const onCreateSurvey = async (data: FormData) => {
		const body = {
			...data,
			respondents: participants.map(item => item.userId)
		};
		
			await post(`/survey`, body);
			onClose();
	};

	const removeRespondent = (participant: Participant) => {
		setParticipants(participants.filter((item) => item.userId !== participant.userId));
		setMembers([
			...members,
			participant,
		]);
	};
	
	const toggleAddRespondentPopup = () => {
		setOpenAddRespondent((prevState:boolean) => !prevState)
	};
	
	const addAllRespondents = () => {
		if(members.length === 0) {
			return;
		}
		setMembers([]);
		setParticipants([...participants, ...members])
	};
	

	return {
		addAllRespondents,
		addRespondent,
		control,
		defaultValues,
		errors,
		handleSubmit,
		onCreateSurvey,
		removeRespondent,
		setSearchName,
		state: {
			members,
			openAddRespondent,
			participants,
		},
		toggleAddRespondentPopup,
	}
}

export default useCreateSurvey;